module.exports = __webpack_public_path__ + "assets/structure-670cb4541431501db4c7de0b0fca799c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/structure.jpg
// module id = 525
// module chunks = 1